export enum TodaStatusEnum {
    None = 0,
    Offline = 1,
    Active = 2
}
